import { render, staticRenderFns } from "./ChallengePreInformationModal.vue?vue&type=template&id=4203a223&scoped=true&"
import script from "./ChallengePreInformationModal.vue?vue&type=script&lang=js&"
export * from "./ChallengePreInformationModal.vue?vue&type=script&lang=js&"
import style0 from "./ChallengePreInformationModal.vue?vue&type=style&index=0&id=4203a223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4203a223",
  null
  
)

export default component.exports